import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRight18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.53033 3.46967L13.0607 9L7.53033 14.5303L6.46967 13.4697L10.9393 9L6.46967 4.53033L7.53033 3.46967Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRight18.displayName = 'ChevronRight18';
export default ChevronRight18;
